export const FLAG_GETTING_SALES_TAXES = 'FLAG_GETTING_SALES_TAXES';
export const GET_SALES_TAXES = 'GET_SALES_TAXES';
export const CLEAR_SALES_TAXES = 'CLEAR_SALES_TAXES';
export const FLAG_GETTING_SALES_TAX = 'FLAG_GETTING_SALES_TAX';
export const GET_SALES_TAX = 'GET_SALES_TAX';
export const CLEAR_SALES_TAX = 'CLEAR_SALES_TAX';
